import { Link } from 'react-router'
import type { OrgPanel } from './homeModel'
import styles from './home.module.css'

/**
 * The orgs the viewer runs, one panel each: the logo with its brand colour,
 * the numbers that matter for that kind of org, and the next thing to do in
 * it. The whole panel opens the org's management.
 */
export function OrgPanels({ panels }: { panels: OrgPanel[] }) {
  if (panels.length === 0) return null
  return (
    <section aria-labelledby="home-run" className={styles.section} data-panel="Yours to run">
      <div className={styles.sectionHead}>
        <h2 id="home-run" className={styles.sectionTitle}>Yours to run</h2>
      </div>
      <div className={styles.panels}>
        {panels.map((panel) => {
          const quiet = !panel.next && panel.figures.every((f) => f.value === 0)
          return (
            <Link
              key={panel.org.id}
              to={panel.manageTo}
              className={[styles.panel, quiet ? styles.panelQuiet : ''].filter(Boolean).join(' ')}
              data-org-panel={panel.org.name}
            >
              <span className={styles.panelHead}>
                <span className={styles.placeMark}>
                  {panel.org.logoUrl
                    ? <img src={panel.org.logoUrl} alt="" className={styles.panelLogo} />
                    : <span className={`${styles.placeInitial} ${styles.panelLogo}`} aria-hidden="true">{panel.org.name.slice(0, 1)}</span>}
                  {panel.org.brandColor && <span className={styles.brandRule} style={{ background: panel.org.brandColor }} aria-hidden="true" />}
                </span>
                <span className={styles.placeText}>
                  <span className={styles.panelName}>{panel.org.name}</span>
                  <span className={styles.placeRole}>
                    {panel.kind === 'league' ? 'League' : 'Club'} · {panel.org.role}
                  </span>
                </span>
              </span>
              {panel.figures.some((f) => f.value > 0) && (
                <dl className={styles.panelFigures}>
                  {panel.figures.map((f) => (
                    <div key={f.label} className={styles.panelFigure}>
                      <dt>{f.label}</dt>
                      <dd>{f.value}</dd>
                    </div>
                  ))}
                </dl>
              )}
              <span className={styles.panelNext}>
                {panel.next
                  ? <>Next: <span className={styles.panelNextText}>{panel.next.title}</span></>
                  : 'Nothing waiting'}
              </span>
            </Link>
          )
        })}
      </div>
    </section>
  )
}
